module.exports = __webpack_public_path__ + "static/top.309a0f32.png";